export default __webpack_public_path__ + "static/media/waitupload.f05a7f4f.png";